<style lang="scss" scoped>
img {
	padding: 5px;
	cursor: pointer;
	&:hover {
		background: #ddd;
		border-radius: 4px;
	}
}
</style>

<template lang="pug">
    img(:src="path(id)", :class="{ selected: id === selected }", @click="select(id)")
</template>

<script>
export default {
	props: {
		selected: {
			type: String,
			default: null
		},
		id: {
			type: String,
			required: true
		}
	},
	methods: {
		path(id) {
			return `https://edu.wonde.com/emoji-assets/32/${id}.png`;
		},
		select(id) {
			this.$emit("click", id);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/emojis/picker/Emoji.vue